import { SvgIcon, SxProps } from "@mui/material";
import CircleXMarkSvg from "jsx:../../../Images/Icons/FontAwesome/solid/circle-xmark.svg";

export function CircleXMarkIcon(props: SxProps) {
    return <SvgIcon component={CircleXMarkSvg} inheritViewBox sx={props} />;
}
